import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { DialogActions, DialogContent } from '../../dialog';


type MessageResetPasswordContentProps = {
  handleClose: () => void;
}

export default ({ handleClose }: MessageResetPasswordContentProps) => {
  return (
    <>
      <DialogContent>
        <Typography>
          An email has been sent with a link to reset your password. Click the link in
          the email and follow the instructions.
          Please email <a href="mailto:niw.selling@simplicitygroup.com" style={{textDecoration: "underline"}}>niw.selling@simplicitygroup.com</a> if you
          are having trouble.
        </Typography>
      </DialogContent>
      <DialogActions style={{ padding: "1rem" }}>
        <Button
          size="small"
          className="floatRight mt20 mb20"
          type="button"
          variant="contained"
          color="primary"
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </>
  )
}
